import React, { useState } from 'react';
import { HoverButton } from '../buttons/base/HoverButton';
import { IconName } from "@fortawesome/fontawesome-svg-core";

interface ChatMessageButtonProps {
  id?: string;
  action: {
    icon: IconName;
    onClick: () => void | Promise<void>;
    label: string;
    clickTimeout?: number;
    highlight?: boolean;
  };
  className?: string;
}

const ChatMessageButtonComponent: React.FC<ChatMessageButtonProps> = ({
  id,
  action,
  className = '',
}) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return;
    
    setLoading(true);
    try {
      const result = action.onClick();
      if (result instanceof Promise) {
        await result;
      }
    } catch (error) {
      console.error('Error in action onClick:', error);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <HoverButton
      id={id}
      icon={action.icon}
      onClick={handleClick}
      title={action.label}
      className={className}
      text={action.label}
      highlight={action.highlight}
      clickTimeout={action.clickTimeout}
      loading={loading}
    />
  );
};

// React.memo verhindert unnötige Re-Renders, wenn Props gleich bleiben
export const ChatMessageButton = React.memo(ChatMessageButtonComponent);